import { Environment } from './environment.model';

export const environment: Environment = {
  name: 'development',
  appTitle: 'SK - Development',
  production: false,
  themeColor: '#ffa500',
  inferenceBackendUrl: 'https://sk-backend-development.swedencentral.cloudapp.azure.com',
  msalConfig: {
    auth: {
      clientId: '0992a3b6-d210-4280-8417-3bbf59b3e268',
      authority:
        'https://login.microsoftonline.com/ee451072-9f9e-4659-a2be-612851a76e70/v2.0/',
      redirectUri:
        'https://sk-frontend-development.swedencentral.cloudapp.azure.com'
    }
  },
  apiConfig: {
    scopes: [
      'openid',
      'email',
      'offline_access',
      //'User.Read',
      'api://119adc6b-9362-4d81-b239-f132051765a7/user_impersonation'
    ],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  ingestionBackendUrl:
    'https://sk-backend.swedencentral.cloudapp.azure.com',
};
